import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
}
const qsAll = {
  links: 'data-footer-link',
}

export const setupFooter = () => {
  cacheDom(dom, qs, qsAll)
  dom.links.forEach(link => {
    link.addEventListener('click', () => {
      setTimeout(() => {
        if(location.hash != '') {
          const details = document.querySelector(location.hash);
          if(details) {
            details.setAttribute('open', '');
            window.scrollTo(0,details.offsetTop - 80);
          }
        }
      }, 500)
    })
  })
}